import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { LightboxModule } from 'ngx-lightbox';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { NgbModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxUsefulSwiperModule } from 'ngx-useful-swiper';
import { NgxTypedJsModule } from 'ngx-typed-js';
import { NgxYoutubePlayerModule } from 'ngx-youtube-player';
import { FlatpickrModule } from 'angularx-flatpickr';
import { CountToModule } from 'angular-count-to';
import { NgxMasonryModule } from 'ngx-masonry';
import { SimplebarAngularModule } from 'simplebar-angular';
import { SharedModule } from "./shared/shared.module";
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { AuthCoverLoginComponent } from './auth/auth-cover-login/auth-cover-login.component';

import { AuthRePasswordThreeComponent } from './auth/auth-re-password-three/auth-re-password-three.component';
import { AuthSignupThreeComponent } from './auth/auth-signup-three/auth-signup-three.component';

import { AccountMembersComponent } from './core/components/account-members/account-members.component';
import { AccountMessagesComponent } from './core/components/account-messages/account-messages.component';
import { AccountProfileComponent } from './core/components/account-profile/account-profile.component';
import { AccountSettingComponent } from './core/components/account-setting/account-setting.component';
import { AccountWorksComponent } from './core/components/account-works/account-works.component';
import { ComponentsComponent } from './core/components/components/components.component';
import { allIcons } from 'angular-feather/icons';


import { IndexHotelComponent } from './core/components/index-hotel/index-hotel.component';
import { IndexTravelComponent } from './core/components/index-travel/index-travel.component';
import { MasterPageComponent } from './core/components/master-page/master-page.component';
import { PageAboutusComponent } from './core/components/page-aboutus/page-aboutus.component';
import { PageBlogDetailComponent } from './core/components/page-blog-detail/page-blog-detail.component';

import { PageComingsoonComponent } from './core/components/page-comingsoon/page-comingsoon.component';

import { PageContactTwoComponent } from './core/components/page-contact-two/page-contact-two.component';

import { PageHistoryComponent } from './core/components/page-history/page-history.component';

import { PagePrivacyComponent } from './core/components/page-privacy/page-privacy.component';
import { PageServicesComponent } from './core/components/page-services/page-services.component';
import { PageTermsComponent } from './core/components/page-terms/page-terms.component';

import { EmailAlertComponent } from './email/email-alert/email-alert.component';
import { EmailConfirmationComponent } from './email/email-confirmation/email-confirmation.component';
import { EmailInvoiceComponent } from './email/email-invoice/email-invoice.component';
import { EmailPasswordResetComponent } from './email/email-password-reset/email-password-reset.component';
import { SwitcherComponent } from './shared/switcher/switcher.component';
import { FeatherModule } from 'angular-feather';
import { NgApexchartsModule } from 'ng-apexcharts';
import { BlogAboutComponent } from './core/components/blog-about/blog-about.component';
import { AccountChatComponent } from './core/components/account-chat/account-chat.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { IndexBlogComponent } from './core/components/index-blog/index-blog.component';
import { EventsComponent } from './shared/Blimb/MasterData/events/events.component';
import { HttpClientModule } from '@angular/common/http';
import { HeaderComponent } from './shared/header/header.component';
import {EventDetailsComponent} from './shared/Blimb/MasterData/event-details/event-details.component';
import { CountryEventsComponent } from './shared/Blimb/MasterData/country-events/country-events.component';
import { EventDetailsInCountryComponent } from './shared/Blimb/MasterData/event-details-in-country/event-details-in-country.component';
import { AddCommentComponent } from './shared/Blimb/Evaluations/add-comment/add-comment.component';
import { CreateExperienceComponent } from './Experiences/components/create-experience/create-experience.component';
import { AllExperiencesComponent } from './Experiences/components/all-experiences/all-experiences.component';
import { EmbedVideo } from 'ngx-embed-video';
import { UploadProfileImageComponent } from './auth/upload-profile-image/upload-profile-image.component';
import { UploadVideoComponent } from './Experiences/components/all-experiences/upload-video/upload-video.component';
import { AllcampsComponent } from './shared/Blimb/Camping/allcamps/allcamps.component';
import { CampsDetailsComponent } from './shared/Blimb/Camping/camps-details/camps-details.component';
import { ExperiencesByTravelerComponent } from './Experiences/components/experiences-by-traveler/experiences-by-traveler.component';
import { MyExperincesComponent } from './Experiences/components/my-experinces/my-experinces.component';
import { AllFoodsComponent } from './shared/Blimb/Foods/all-foods/all-foods.component';
import { FoodDetailsComponent } from './shared/Blimb/Foods/food-details/food-details.component';
import { AllAdventuresComponent } from './shared/Blimb/Adventures/all-adventures/all-adventures.component';
import { AdventureDeleailsComponent } from './shared/Blimb/Adventures/adventure-deleails/adventure-deleails.component';
import { AllSouvenirsComponent } from './shared/Blimb/Souvenirs/all-souvenirs/all-souvenirs.component';
import { SouvenirDetailsComponent } from './shared/Blimb/Souvenirs/souvenir-details/souvenir-details.component';
import { AllVisasComponent } from './shared/Blimb/Visas/all-visas/all-visas.component';
import { VisaDetailsComponent } from './shared/Blimb/Visas/visa-details/visa-details.component';
import { ToastrModule } from 'ngx-toastr';
import { TestVideoComponent } from './Experiences/components/test-video/test-video.component';
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    AccountMembersComponent,
    AccountMessagesComponent,
    MasterPageComponent,
    AccountProfileComponent,
    AccountSettingComponent,
    AccountWorksComponent,
    AuthCoverLoginComponent,
    AuthRePasswordThreeComponent,
    AuthSignupThreeComponent,
    ComponentsComponent,
    EmailAlertComponent,
    EmailConfirmationComponent,
    EmailInvoiceComponent,
    EmailPasswordResetComponent,
    IndexHotelComponent,
    IndexTravelComponent,
    PageAboutusComponent,
    PageBlogDetailComponent,
    PageComingsoonComponent,
    PageContactTwoComponent,
    PageHistoryComponent,
    PagePrivacyComponent,
    PageServicesComponent,
    PageTermsComponent,
    SwitcherComponent,
    BlogAboutComponent,
    AccountChatComponent,
    IndexBlogComponent,
    EventsComponent,
    EventDetailsComponent,
    CountryEventsComponent,
    EventDetailsInCountryComponent,
    AddCommentComponent,
    CreateExperienceComponent,
    AllExperiencesComponent,
    UploadProfileImageComponent,
    UploadVideoComponent,
    AllcampsComponent,
    CampsDetailsComponent,
    ExperiencesByTravelerComponent,
    MyExperincesComponent,
    AllFoodsComponent,
    FoodDetailsComponent,
    AllAdventuresComponent,
    AdventureDeleailsComponent,
    AllSouvenirsComponent,
    SouvenirDetailsComponent,
    AllVisasComponent,
    VisaDetailsComponent,
    TestVideoComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    RouterModule,
    CarouselModule,
    FeatherModule.pick(allIcons),
    ScrollToModule.forRoot(),
    RouterModule.forRoot([], {}),
    ToastrModule.forRoot(),
    NgxYoutubePlayerModule,
    NgbDropdownModule,
    CKEditorModule,
    NgbModule,
    NgbNavModule,
    FormsModule,
    ReactiveFormsModule,
    NgxUsefulSwiperModule,
    NgApexchartsModule,
    NgxTypedJsModule,
    FlatpickrModule.forRoot(),
    CountToModule,
    NgxMasonryModule,
    LightboxModule,
    SharedModule,
    SimplebarAngularModule,
    SharedModule,
    GoogleMapsModule,
     HttpClientModule, 
     EmbedVideo.forRoot(),
 
  ],
  exports: [
    FeatherModule,
    HeaderComponent,
    UploadProfileImageComponent,
    UploadVideoComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  providers: [
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
